import React, { useCallback, useEffect } from 'react';
import { FlowConfiguration, MockService } from 'types/rest/mockServiceTypes';
import ComponentList from 'components/lists/ComponentList/ComponentList';
import FlowConfigurationItem from '../ListRenderComponents/FlowConfigurationItem';
import _ from 'lodash';
import { useIsMount } from '../../../../../../../hooks/useIsMountHook';

interface Props {
  mockService: MockService;
  disabled: boolean;
  onChange: (flowConfigurations: FlowConfiguration[]) => void;
}

const FlowConfigurations = ({ mockService, disabled, onChange }: Props) => {
  const getFlowConfig: FlowConfiguration[] = mockService.brokerConfig?.flowConfigurations || [];

  const [flowConfigurations, setFlowConfigurations] = React.useState<FlowConfiguration[]>(getFlowConfig);
  const isMount = useIsMount();

  const updateFlowConfiguration = useCallback(
    _.debounce(flowConfig => {
      onChange(flowConfig);
    }, 600),
    [mockService, disabled],
  );

  useEffect(() => {
    if (!isMount) {
      updateFlowConfiguration(flowConfigurations);
    }
  }, [flowConfigurations]);

  return (
    <div>
      <p>
        Configure a flow to define how messages are transmitted from the source to the destination. When a message
        arrives at the inbound destination, it triggers the generation of one or more messages that are subsequently
        directed to the outbound destination. You may assign a name to the flow, enabling its reuse within the
        transaction configuration as needed.
      </p>
      <ComponentList
        list={flowConfigurations}
        renderItem={FlowConfigurationItem}
        onListChange={flowConfigurations => {
          setFlowConfigurations(flowConfigurations);
        }}
        onAddNewItem={() => {
          const flowConfig: FlowConfiguration = { name: '' };
          setFlowConfigurations([...flowConfigurations, flowConfig]);
        }}
        disabled={disabled}
        emptyListMessage={'No flow configurations have been defined yet.'}
        label={'Flows'}
        metadata={mockService.brokerConfig}
      />
    </div>
  );
};

export default FlowConfigurations;
